// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2x5I2","input":"styles_input__2pths"};